/* global axios */
import ApiClient from '../ApiClient';

// Company Page do LinkedIn da empresa. Não passa pela WAME: é OAuth direto com a
// API oficial, e o Laravel guarda os tokens por trás da ponte do Rails.
class LinkedinIntegration extends ApiClient {
  constructor() {
    super('aceleres/linkedin', { accountScoped: true });
  }

  status() {
    return axios.get(this.url);
  }

  // Devolve a URL de autorização do LinkedIn. A volta para esta tela é decidida
  // no servidor, não aqui.
  authorize() {
    return axios.post(`${this.url}/authorize`);
  }

  disconnect() {
    return axios.post(`${this.url}/disconnect`);
  }
}

export default new LinkedinIntegration();
